/**
 * Formats a Date object to YYYY/MM/DD HH:mm:ss format (local time, no timezone)
 * @param {Date} date - The date to format
 * @returns {string|null} Formatted date string or null if invalid
 */
export function formatDateTimeLocal(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
  const pad = n => String(n).padStart(2, "0");
  return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
